// extracted by mini-css-extract-plugin
module.exports = {"section_mentor_list":"mentor_list_section_mentor_list__wmF4U"};